import { User } from "@/core/services/api/interfaces/manager/User";
import { BankAccount } from "@/core/services/api/interfaces/manager/BankAccount";

export interface ImportItem {
  id: number;
  file_name: string | null;
  bank_account: BankAccount | null;
  user: User | null;
  failed_transactions_amount: number | null;
  failed_transactions_count: number | null;
  success_transactions_amount: number | null;
  success_transactions_amount_with_fee: number | null;
  success_transactions_count: number | null;
  actions: {
    is_downloadable: boolean;
    has_errors: boolean;
  };
  status: ImportStatus;
  errors: object[] | null;
  created_at: string;
  updated_at: string;
}

export enum ImportStatus {
  QUEUE = "QUEUE",
  PROCESSING = "PROCESSING",
  ERROR = "ERROR",
  DONE = "DONE",
}
